import { Dialog, DialogActions, DialogContent } from "@material-ui/core";
import Button from "@material-ui/core/Button";
import Grid from "@material-ui/core/Grid";
import { makeStyles } from "@material-ui/styles";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import EnhancedConfirmButton from "src/components/enhanced/EnhancedConfirmButton";
import EnhancedDialogTitle from "src/components/enhanced/EnhancedDialogTitle";
import EnhancedSelect from "src/components/enhanced/EnhancedSelect";
import EnhancedTextField from "src/components/enhanced/EnhancedTextField";
import { addDailyNote, deleteDailyNote, editDailyNote } from "src/features/dailyNoteSlice";
//import { fetchRooms } from "src/features/listsSlice";
import { getSessionCheckedCompany, getSessionCheckedRooms } from "src/helpers/sessionHelper";
import alertHelper from "src/helpers/alertHelper";
import EnhancedDateField from "src/components/enhanced/EnhancedDateField";

function DailyNoteDialog(props) {
  const classes = useStyles();
  const dispatch = useDispatch();

  const dataById = useSelector((state) => state.dailyNote.dataById);
  const roomList = useSelector((state) => state.lists.roomList);

  const { selected, setSelected, openDailyNote, setOpenDailyNote } = props;

  const [formState, setFormState] = useState({});

//  useEffect(() => {
  //  if (getSessionCheckedCompany() && openDailyNote) dispatch(fetchRooms(getSessionCheckedCompany()));
//  }, [openDailyNote, dispatch, selected]);

  useEffect(() => {
    if (openDailyNote && dataById[selected]) {
      setFormState((formState) => ({
        ...formState,
        id: dataById[selected]?.id,
        note: dataById[selected]?.title,
        date: dataById[selected]?.date,
        room: dataById[selected]?.room?.id
      }));
    }
  }, [openDailyNote, dataById, selected, setFormState]);

  useEffect(() => {
    if (openDailyNote && selected === null && getSessionCheckedRooms().length === 1) {
      setFormState((formState) => ({
        ...formState,
        room: getSessionCheckedRooms().map((c) => c[0])[0]
      }));
    }
  }, [setFormState, openDailyNote, selected]);

  function handleChange(event) {
    event.persist();
    setFormState((formState) => ({
      ...formState,
      [event.target.name]: event.target.value
    }));
  }

  function handleClose() {
    setSelected(null);
    setFormState({});
    setOpenDailyNote(false);
  }

  function handleOk() {
    const apiData = {
      note: formState.note,
      date: formState.date,
      roomId: formState.room
    };

    handleClose();

    if (dataById[selected]) {
      apiData.id = formState.id;
      dispatch(editDailyNote(apiData));
    } else {
      dispatch(addDailyNote(apiData));
    }
  }

  const handleDelete = () => {
    alertHelper.confirm({
      message: "Opravdu si přejete smazat tuto denní poznámku?",
      callback: () => dispatch(deleteDailyNote(formState.id))
    });

    handleClose();
  };

  function isDisabledFields() {
    return formState.id;
  }

  return (
    <div className={classes.root}>
      <Dialog
        open={openDailyNote}
        onClose={handleClose}
        aria-labelledby="form-dialog-title"
        fullWidth={true}
        maxWidth="md">
        <EnhancedDialogTitle handleClose={handleClose} nameLabel="Denní poznámka" />
        <DialogContent>
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <EnhancedTextField name="note" value={formState.note || ""} label="Poznámka" onChange={handleChange} />
            </Grid>
            <Grid item xs={6}>
              <EnhancedDateField
                  disabled={isDisabledFields()}
                  name="date"
                  value={formState.date || ""}
                  label="Datum"
                  handleChange={handleChange}
              />
            </Grid>
            <Grid item xs={6}>
              <EnhancedSelect
                disabled={isDisabledFields()}
                name="room"
                value={formState.room || ""}
                label="Masérna"
                list={roomList}
                onChange={handleChange}
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={handleDelete}
            disabled={!formState.id}
            color="secondary"
            variant="contained"
            className={classes.delete}>
            Smazat
          </Button>
          <EnhancedConfirmButton handleOk={handleOk} disabledOk={false} />
        </DialogActions>
      </Dialog>
    </div>
  );
}

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1
  },
  delete: {
    color: "white",
    background: "red",
    "&:hover": {
      color: "white",
      background: "#B22222"
    }
  }
}));

export default DailyNoteDialog;
